import { TableRow } from '@mui/material';

import { TableBodyCell } from '../table-cells/TableCells';

import {
  useGetAuthenticationQuery,
  useGetProfilesQuery,
} from '../../services/ADapi';

const UsersListItem = ({
  id,
  user_name,
  collections,
  profileId,
  os_info,
  hostname,
  last_seen,
}) => {
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();

  const { data: profile = {} } = useGetProfilesQuery(user_id, {
    selectFromResult: ({ data, isLoading }) => ({
      isLoading,
      data: data?.find((profile) => profile.id === profileId),
    }),
  });

  return (
    <TableRow
      key={id}
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
    >
      <TableBodyCell scope="row">{user_name}</TableBodyCell>
      <TableBodyCell align="left">{collections}</TableBodyCell>
      <TableBodyCell align="left">{profile.name}</TableBodyCell>
      <TableBodyCell align="left">{hostname}</TableBodyCell>
      <TableBodyCell align="left">{os_info}</TableBodyCell>
      <TableBodyCell align="left">{last_seen.split('T')[0]}</TableBodyCell>
    </TableRow>
  );
};

export default UsersListItem;
